// extracted by mini-css-extract-plugin
export default {"CreateVersion":"CreateVersionPkwFXKG9LNOb","CreateVersion-icon":"CreateVersion-icondQe0NJgON84O"};